export const PAGE_SIZE = 15

export const splitToChunks = <T>(arr: T[], size = PAGE_SIZE) => Array.from({ length: Math.ceil(arr.length / size) }, (_v, i) => arr.slice(i * size, i * size + size))
